import { useDebounce, useSetState } from '@src/hooks'

const defaultState = {
  filterString: '',
}

function useFilterString(options = {}){
  const { debounce = 50 } = options || {}

  const [state, setState] = useSetState(defaultState)
  const { filterString } = state
  const debouncedFilterString = useDebounce(filterString, debounce)

  return {
    debouncedFilterString,
    onChange: e => setState({ filterString: e.target.value }),
    resetString: () => setState({ filterString: '' }),
    value: filterString,
  }
}

export default useFilterString
